var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93605 0.970459C1.63632 0.970459 0.57959 2.02719 0.57959 3.32692V15.1092C0.57959 16.409 1.63632 17.4657 2.93605 17.4657H14.7184C16.0181 17.4657 17.0748 16.409 17.0748 15.1092V3.32692C17.0748 2.02719 16.0181 0.970459 14.7184 0.970459H2.93605ZM13.8752 4.06332L10.0533 8.43014L14.549 14.3728H11.029L8.27492 10.7682L5.11946 14.3728H3.37053L7.45752 9.70042L3.14593 4.06332H6.75426L9.24696 7.35868L12.1263 4.06332H13.8752ZM12.4834 13.3272L6.22774 5.05377H5.18574L11.5114 13.3272H12.4797H12.4834Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXW);
export default __webpack_public_path__ + "static/media/x-w.f7acb891682cc2bc2cd85bb78511ad0e.svg";
export { ForwardRef as ReactComponent };